import { render, staticRenderFns } from "./testscreen.vue?vue&type=template&id=781d73d0&"
import script from "./testscreen.vue?vue&type=script&lang=js&"
export * from "./testscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781d73d0')) {
      api.createRecord('781d73d0', component.options)
    } else {
      api.reload('781d73d0', component.options)
    }
    module.hot.accept("./testscreen.vue?vue&type=template&id=781d73d0&", function () {
      api.rerender('781d73d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/testscreen.vue"
export default component.exports